// Dashboard, sites, staff and audit-log screens.
export const screensEn = {
  'dashboard.welcome': 'Welcome, {name}',
  'dashboard.subtitle': 'The platform at a glance.',
  'dashboard.sites': 'Sites',
  'dashboard.activeSites': 'Active sites',
  'dashboard.suspendedSites': 'Suspended sites',
  'dashboard.staff': 'Staff',
  'dashboard.failedBuilds': 'Failed builds (7 days)',
  'dashboard.open': 'Open',
  'dashboard.recent': 'Recent activity',
  'dashboard.recentHint': 'The last ten changes in the console.',
  'dashboard.noActivity': 'Nothing yet.',
  'sites.title': 'Sites',
  'sites.subtitle': 'Every web + adminweb pair on the platform.',
  'sites.col.site': 'Site',
  'sites.col.package': 'Package',
  'sites.col.status': 'Status',
  'sites.col.usage': 'Pages · users',
  'sites.col.synced': 'Last sync',
  'sites.empty.title': 'No sites yet',
  'sites.empty.hint': 'Registered sites appear here with their package, status and usage.',
  'sites.status.active': 'Active',
  'sites.status.suspended': 'Suspended',
  'sites.syncFailed': 'Sync failed',
  'sites.notSynced': 'Not synced',
  'pkg.starter': 'Starter',
  'pkg.business': 'Business',
  'pkg.advanced': 'Advanced',
  'pkg.store': 'Store',
  'staff.title': 'Staff',
  'staff.subtitle': 'The people who run the platform.',
  'staff.invite': 'Add staff',
  'staff.ownerOnly': 'Only owners can manage staff.',
  'staff.col.name': 'Name',
  'staff.col.role': 'Role',
  'staff.col.status': 'Status',
  'staff.col.lastLogin': 'Last sign-in',
  'staff.col.actions': 'Actions',
  'staff.deactivate': 'Deactivate',
  'staff.reactivate': 'Reactivate',
  'staff.deactivate.title': 'Deactivate {name}?',
  'staff.deactivate.body': 'They are signed out and cannot sign in until reactivated.',
  'staff.toast.roleUpdated': 'Role updated',
  'staff.toast.deactivated': 'Staff member deactivated',
  'staff.toast.reactivated': 'Staff member reactivated',
  'staff.create.title': 'Add a staff member',
  'staff.create.name': 'Name',
  'staff.create.email': 'Email',
  'staff.create.role': 'Role',
  'staff.create.password': 'Temporary password',
  'staff.create.passwordHint': 'At least {min} characters. They can change it from Profile.',
  'staff.create.submit': 'Add staff member',
  'staff.create.submitting': 'Adding…',
  'staff.create.done': '{name} was added',
  'audit.title': 'Audit log',
  'audit.subtitle': 'Who did what in the console (latest 200).',
  'audit.col.when': 'When',
  'audit.col.who': 'Who',
  'audit.col.action': 'Action',
  'audit.col.detail': 'Detail',
  'audit.system': 'System',
  'audit.empty': 'Nothing has been recorded yet.',
  'audit.action.auth.login': 'Signed in',
  'audit.action.auth.login_failed': 'Failed sign-in',
  'audit.action.auth.password_change': 'Changed password',
  'audit.action.staff.create': 'Added a staff member',
  'audit.action.staff.update': 'Updated a staff member',
  'audit.action.staff.deactivate': 'Deactivated a staff member',
} as const

export const screensId: Record<keyof typeof screensEn, string> = {
  'dashboard.welcome': 'Selamat datang, {name}',
  'dashboard.subtitle': 'Gambaran singkat platform.',
  'dashboard.sites': 'Situs',
  'dashboard.activeSites': 'Situs aktif',
  'dashboard.suspendedSites': 'Situs ditangguhkan',
  'dashboard.staff': 'Staf',
  'dashboard.failedBuilds': 'Build gagal (7 hari)',
  'dashboard.open': 'Buka',
  'dashboard.recent': 'Aktivitas Terbaru',
  'dashboard.recentHint': 'Sepuluh perubahan terakhir di console.',
  'dashboard.noActivity': 'Belum ada aktivitas.',
  'sites.title': 'Situs',
  'sites.subtitle': 'Setiap pasangan web + adminweb di platform.',
  'sites.col.site': 'Situs',
  'sites.col.package': 'Paket',
  'sites.col.status': 'Status',
  'sites.col.usage': 'Halaman · pengguna',
  'sites.col.synced': 'Sinkron terakhir',
  'sites.empty.title': 'Belum ada situs',
  'sites.empty.hint': 'Situs yang terdaftar muncul di sini beserta paket, status, dan penggunaannya.',
  'sites.status.active': 'Aktif',
  'sites.status.suspended': 'Ditangguhkan',
  'sites.syncFailed': 'Sinkronisasi gagal',
  'sites.notSynced': 'Belum disinkronkan',
  'pkg.starter': 'Starter',
  'pkg.business': 'Business',
  'pkg.advanced': 'Advanced',
  'pkg.store': 'Store',
  'staff.title': 'Staf',
  'staff.subtitle': 'Orang-orang yang menjalankan platform.',
  'staff.invite': 'Tambah staf',
  'staff.ownerOnly': 'Hanya pemilik yang dapat mengelola staf.',
  'staff.col.name': 'Nama',
  'staff.col.role': 'Peran',
  'staff.col.status': 'Status',
  'staff.col.lastLogin': 'Masuk terakhir',
  'staff.col.actions': 'Aksi',
  'staff.deactivate': 'Nonaktifkan',
  'staff.reactivate': 'Aktifkan kembali',
  'staff.deactivate.title': 'Nonaktifkan {name}?',
  'staff.deactivate.body': 'Mereka akan dikeluarkan dan tidak dapat masuk sampai diaktifkan kembali.',
  'staff.toast.roleUpdated': 'Peran diperbarui',
  'staff.toast.deactivated': 'Staf dinonaktifkan',
  'staff.toast.reactivated': 'Staf diaktifkan kembali',
  'staff.create.title': 'Tambah staf',
  'staff.create.name': 'Nama',
  'staff.create.email': 'Email',
  'staff.create.role': 'Peran',
  'staff.create.password': 'Kata sandi sementara',
  'staff.create.passwordHint': 'Minimal {min} karakter. Mereka dapat mengubahnya dari Profil.',
  'staff.create.submit': 'Tambah staf',
  'staff.create.submitting': 'Menambahkan…',
  'staff.create.done': '{name} ditambahkan',
  'audit.title': 'Log audit',
  'audit.subtitle': 'Siapa melakukan apa di console (200 terbaru).',
  'audit.col.when': 'Waktu',
  'audit.col.who': 'Siapa',
  'audit.col.action': 'Tindakan',
  'audit.col.detail': 'Detail',
  'audit.system': 'Sistem',
  'audit.empty': 'Belum ada yang tercatat.',
  'audit.action.auth.login': 'Masuk',
  'audit.action.auth.login_failed': 'Gagal masuk',
  'audit.action.auth.password_change': 'Mengubah kata sandi',
  'audit.action.staff.create': 'Menambah staf',
  'audit.action.staff.update': 'Memperbarui staf',
  'audit.action.staff.deactivate': 'Menonaktifkan staf',
}
